import { render, staticRenderFns } from "./IconSvgMessages.vue?vue&type=template&id=2fa528e9&scoped=true&"
import script from "./IconSvgMessages.vue?vue&type=script&lang=js&"
export * from "./IconSvgMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa528e9",
  null
  
)

export default component.exports